import { gql, TypedDocumentNode } from "@apollo/client";

import { ApiKeyLegacyListView } from "components/ApiKeys/types";
import { Seats } from "types/generated";

type GetPersonalApiKeysLegacyData = {
  viewer: { apiKeys: ApiKeyLegacyListView[] } | null;
  seats: Pick<Seats, "apiKey">;
};

export const GET_PERSONAL_API_KEYS_LEGACY: TypedDocumentNode<GetPersonalApiKeysLegacyData> = gql`
  query GetPersonalApiKeysLegacy {
    viewer {
      id
      apiKeys {
        id
        createdAt
        description
        admin
        teams
        type
        teamCount
        lastUsedAt
        expiresAt
        creator
        name
        spaceCount
        accessRules {
          space
          spaceAccessLevel
        }
        oidcSettings {
          clientId
          issuer
          subjectExpression
        }
      }
    }
    seats {
      apiKey {
        limit
        inUse
      }
    }
  }
`;
